module.exports = __webpack_public_path__ + "static/media/avatar.1d962538.svg";